import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
}), 'SmsFailedOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SmsFailedOutlined.js
// module id = 6300
// module chunks = 2